import { UserCreateRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const createRoute = {
  path: 'create',
  element: <UserCreateRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Create</span>,
  }),
};